/*
 -----------------
 DFP MANAGER
 -----------------

 Sets up DFP, allowing our ads to fire

 */

class DFP {
  constructor() {
    this.initAdSlots = this.initAdSlots.bind(this);
    this.unloadAds = this.unloadAds.bind(this);
  }

  // Fetches the required google Ad Manager script, then calls back with a Promise resolution once done.
  fetchScript(resolve) {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    (function() {
      const gads = document.createElement('script');
      const useSSL = document.location.protocol == 'https:';
      gads.src = `${
        useSSL ? 'https:' : 'http:'
      }//www.googletagservices.com/tag/js/gpt.js`;
      gads.type = 'text/javascript';

      gads.async = true;
      gads.onload = resolve;
      document.head.appendChild(gads);
    })();
  }

  // Initialises the adslots and calls display on them to get them ready
  initAdSlots() {

    console.log("~~~~~~~~~~~~~~~~~~~~ INITIALISING ADSLOTS ON PAGE!");
    window.googletag.cmd.push(() => {
      for(let x = window.AdManager.unactionedAdSlots.length -1; x > -1; x--) {

        const adSlot = window.AdManager.unactionedAdSlots[x];
        console.log(adSlot);

        adSlot.init();
        AdManager.adDefinitions[adSlot.metadata.div] = adSlot.definition;
        window.googletag.display(adSlot.metadata.div);

        window.AdManager.adSlots.push(adSlot);
        window.AdManager.unactionedAdSlots.splice(x, 1);
      }

    });
  }

  // Allows Google Ad Manager to start serving ads
  enableServices() {
    window.googletag.cmd.push(() => {
      window.googletag.enableServices();
    });
  }

  // Initialiases Google Ad Manager, then resolves a Promise
  initDFP(resolvePrior) {
    window.googletag.cmd.push(() => {
      window.googletag.pubads().enableAsyncRendering();
      window.googletag.pubads().collapseEmptyDivs(false);
      window.googletag.pubads().setCentering(true);
      window.googletag.pubads().disableInitialLoad();
      window.googletag.pubads().enableVideoAds();
      resolvePrior();
    });
  }


  // Safely removes all ads from pubads
  unloadAllAds() {
    window.googletag.cmd.push(() => {
      console.log("~~~~~~~~~~~~~~~~~~~~ DESTROYING ADSLOTS ON PAGE!");
      window.googletag.destroySlots();
    });
  }


  // Safely removes ads from pubads
  unloadAds(adSlots, callBack) {
    console.log("---");
    console.log("UNLOADING AD SLOTS");

    const adDefinitions = [];
    const adDivs = [];
    adSlots.forEach( targetAd => {
      adDivs.push(targetAd.metadata.div);
      adDefinitions.push(targetAd.definition);
    });
    console.log(adDefinitions);

    adDivs.forEach(divId => {
      const thisAd = document.querySelector(`#${divId}`);
      if (thisAd) {
        thisAd.style.minHeight = `${thisAd.clientHeight}px`;
      }
    });

    const results = new Promise(resolve => {
      window.googletag.cmd.push(() => {
        adDefinitions.forEach( slot =>{
          console.log(slot);
            const removedAdslot = window.googletag.destroySlots([slot]);
            console.log(removedAdslot);
          }
        );
        resolve();
      });
    });

    Promise.all([results]).then(() => {
      callBack();
    })

  }


  // Apply all targeting currently banked up, then remove the stored Targeting values once they've been applied
  applyTargeting() {
    const globalTargeting = AdManager.globalTargeting;
    const singleTargeting = AdManager.singleTargeting;
    const unactionedGlobalTargeting = AdManager.unactionedGlobalTargeting;
    const unactionedSingleTargeting = AdManager.unactionedSingleTargeting;

    window.googletag.cmd.push(() => {
      for (const keyName in unactionedGlobalTargeting) {
        if (unactionedGlobalTargeting.hasOwnProperty(keyName)) {
          window.googletag
            .pubads()
            .setTargeting(keyName, unactionedGlobalTargeting[keyName]);
        }
      }

      AdManager.unactionedGlobalTargeting = [];

      for (const divID in unactionedSingleTargeting) {
        if (unactionedSingleTargeting.hasOwnProperty(divID)) {
          const relevantAdslot = AdManager.adSlots.find(
            adSlot => adSlot.div === divID
          );

          if (relevantAdslot) {
            for (const keyName in unactionedSingleTargeting[divID]) {
              if (unactionedSingleTargeting[divID].hasOwnProperty(keyName)) {
                relevantAdslot.definition.setTargeting(
                  keyName,
                  unactionedSingleTargeting[divID][keyName]
                );
              }
            }
          }
        }
      }

      unactionedSingleTargeting.forEach((divID, targetingArray) => {
        const relevantAdslot = AdManager.adSlots.find(
          adSlot => adSlot.div === divID
        );
        if (relevantAdslot) {
          targetingArray.forEach((key, index) => {
            relevantAdslot.definition.setTargeting(key, index);
          });
        }
      });

      AdManager.unactionedSingleTargeting = [];
    });

    return true;
  }
}

export default () => new DFP();
